import React, { Component, Fragment } from 'react';
import { Row, Col } from 'react-materialize';
import { connect } from 'react-redux';
import * as actions from '../../redux/actions/index';

import Speaker from './Speaker';
import Title from './Title';
import Player from './Player';
import Connection from './Connection';
import TEST_STATUS from '../../constants/status';

/* Google analytics */
import ReactGA from 'react-ga4';
import SessionStatus from '../../analytics/analytics-events/SessionStatus';
import { UserEvent } from '../../analytics/analytics-events/constants';
import settings from '../../libs/config';
import { Redirect } from 'react-router-dom';

ReactGA.initialize([{ trackingId: settings.gaCode }]);

class Tests extends Component {
	constructor(props) {
		super(props);

		this.finish = this.finish.bind(this);
		this.triggerFailureGoogleAnalyticsEvent = this.triggerFailureGoogleAnalyticsEvent.bind(this);
	}

	finish() {
		this.props.setTechCheckFinishedStatus(true);
	}

	triggerFailureGoogleAnalyticsEvent(type) {
		const tracker = this.props.tracker ? this.props.tracker : ReactGA;
		const sessionStatus = new SessionStatus(
			UserEvent.TECH_CHECK_FAIL,
			'',
			'',
			false,
			false,
			true
		);
		sessionStatus.gaTracker = tracker;
		sessionStatus.type = type;
		this.props.globalAnalyticsAdapter.reportAnalyticsEvent(sessionStatus);
	}

	render() {
		const {
			speaker,
			player,
			connection,
			connectionSpeed,
			techCheckFinished,
		} = this.props;
		const results = [speaker, player, connection, connectionSpeed];
		const passed = results.every((result) => result === TEST_STATUS.success);

		if (passed && techCheckFinished) {
			return <Redirect to="/register" />;
		}

		return (
			<Fragment>
				<Row className="valign-wrapper dp-container mb-0">
					<Col s={12}>
						<Title />
					</Col>
				</Row>
				<Row className="valign-wrapper dp-container mb-0 horizontal-top-separator">
					<Col s={12}>
						<Speaker onFail={this.triggerFailureGoogleAnalyticsEvent} />
					</Col>
				</Row>
				<Row className="valign-wrapper dp-container mb-0 horizontal-top-separator">
					<Col s={12}>
						<Player onFail={this.triggerFailureGoogleAnalyticsEvent} />
					</Col>
				</Row>
				<Row className="valign-wrapper dp-container mb-0 horizontal-top-separator">
					<Col s={12}>
						<Connection onFail={this.triggerFailureGoogleAnalyticsEvent} />
					</Col>
				</Row>
				<Row className="valign-wrapper dp-container mb-0 confirmation-button">
					<Col s={12}>
						<button disabled={!passed} onClick={this.finish}>
							GO
						</button>
					</Col>
				</Row>
			</Fragment>
		);
	}
}

const mapStateToProps = (state) => ({
	speaker: state.techCheck.speaker,
	player: state.techCheck.player,
	connection: state.techCheck.connection,
	connectionSpeed: state.techCheck.connectionSpeed,
	techCheckFinished: state.techCheck.techCheckFinished,

	tracker: state.GlobalAnalyticsAdapterReducer.gaTracker,
	globalAnalyticsAdapter:
		state.GlobalAnalyticsAdapterReducer.globalAnalyticsAdapter,
});

export default connect(mapStateToProps, actions)(Tests);



// WEBPACK FOOTER //
// ./src/components/tech-check/Tests.js